import api from '@/api/feature-flags';

const actions = {
  async FETCH_FEATURE_FLAGS({ commit }) {
    const featureFlags = await api.fetchFeatureFlags();

    commit('SET_FEATURE_FLAGS', featureFlags);
    return featureFlags;
  },
};

export default actions;
